import * as React from "react";
import styled, { css } from "styled-components";

import {
  FormRow,
  Input,
  Switch
} from "src/library/components/Forms";
import { Text } from "src/library/components/Text";
import { IInheritedSetting } from "src/core/drops/api/drops.api";
import { useCurrentUser } from "src/core/users/hooks";
import type { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";

interface OrderDataRequirementsProps {
  settingValue: IInheritedSetting<"order_data_requirements">["value"];
  terminology: ITerminology;
  setSettingValue: (settingValue: IInheritedSetting<"order_data_requirements">["value"]) => void;
}
export const OrderDataRequirements: React.ReactFCWithChildren<OrderDataRequirementsProps> = ({
  settingValue, terminology, setSettingValue
}) => {
  const [ { currentRole } ] = useCurrentUser();

  return (typeof settingValue.orderPONumber === "object" ? (
    <OrderDataRequirementsWrapper>
      <FormRow>
        <Text as="p">
          The below settings control how the PO number should be validated.
        </Text>

        <Input
          name="po-regex"
          label="Regex"
          value={settingValue.orderPONumber.regex}
          disabled={currentRole?.code !== "super-admin"}

          handleChange={e => typeof settingValue.orderPONumber === "object" && setSettingValue({
            orderPONumber: {
              ...settingValue.orderPONumber,
              regex: e.currentTarget.value
            }
          }
          )}
        />
      </FormRow>

      <FormRow>
        <Input
          name="po-max-length"
          label="Max Length"
          value={settingValue.orderPONumber.maxLength}
          disabled={currentRole?.code !== "super-admin"}
          inputType="number"
          handleChange={e => typeof settingValue.orderPONumber === "object" && setSettingValue({
            orderPONumber: {
              ...settingValue.orderPONumber,
              maxLength: parseInt(e.currentTarget.value, 10)
            }
          })}
        />
      </FormRow>

      <FormRow>
        <Input
          name="po-error-message"
          label="Error Message"
          value={settingValue.orderPONumber.message}
          handleChange={e =>
            typeof settingValue.orderPONumber === "object" && setSettingValue({
              orderPONumber: {
                ...settingValue.orderPONumber,
                message: e.currentTarget.value
              }
            })}
        />
      </FormRow>

      <FormRow>
        <div className="field-unique">
          <Text fontSize="h4">
            {`Unique to ${terminology.drop.singular.text} and their delivery date`}
          </Text>
        </div>

        <Switch
          checked={settingValue.orderPONumber.unique || false}
          onChange={checked =>
            typeof settingValue.orderPONumber === "object" && setSettingValue({
              orderPONumber: {
                ...settingValue.orderPONumber,
                unique: checked
              }
            })}
        />
      </FormRow>
    </OrderDataRequirementsWrapper>
  ) : null
  );
};

const OrderDataRequirementsWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.margins.md};

    .field-unique {
      margin-bottom: ${theme.spacing.margins.sm};
    }
  `}
`;
